import { render, staticRenderFns } from "./CharacterSelect.vue?vue&type=template&id=cf5bdaa4&scoped=true&"
import script from "./CharacterSelect.vue?vue&type=script&lang=js&"
export * from "./CharacterSelect.vue?vue&type=script&lang=js&"
import style0 from "./CharacterSelect.vue?vue&type=style&index=0&id=cf5bdaa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5bdaa4",
  null
  
)

component.options.__file = "CharacterSelect.vue"
export default component.exports